import script from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=0897d52d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0897d52d"]])

export default __exports__